/**
 * This index.js file is the entry point for search page components.
 **/

import MultiUnitHit from '../components/MultiUnitHit/MultiUnitHit';
import {triggerMultiUnitHitExposedEDAPEvent} from '../components/MultiUnitHit/utils/edap';

export {MultiUnitHit, triggerMultiUnitHitExposedEDAPEvent};
